var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSearchCustomerCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20Z",
    fill: "#0033AD",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 21V28H12V14H17.02C17.07 13.29 17.24 12.62 17.5 12H12C10.9 12 10 12.9 10 14V28C10 29.1 10.9 30 12 30H26C27.1 30 28 29.1 28 28V23L26 21ZM27.3 16.89C27.74 16.19 28 15.38 28 14.5C28 12.01 25.99 10 23.5 10C21.01 10 19 12.01 19 14.5C19 16.99 21.01 19 23.49 19C24.37 19 25.19 18.74 25.88 18.3L29 21.42L30.42 20L27.3 16.89ZM23.5 17C22.12 17 21 15.88 21 14.5C21 13.12 22.12 12 23.5 12C24.88 12 26 13.12 26 14.5C26 15.88 24.88 17 23.5 17Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 23C20.105 23 21 22.105 21 21C21 19.895 20.105 19 19 19C17.895 19 17 19.895 17 21C17 22.105 17.895 23 19 23ZM19 24C17.665 24 15 24.67 15 26V27H23V26C23 24.67 20.335 24 19 24Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchCustomerCircle);
export default __webpack_public_path__ + "static/media/ic_search_customer_circle.0635a1c052d31cf2229ef3a1f98ec2dc.svg";
export { ForwardRef as ReactComponent };